import { useLanguage } from '../../contexts/LanguageContext';
import { useState, useEffect, useCallback } from 'react';

const FLAGS = {
  ar: '/assets/flags/en.svg',
  en: '/assets/flags/ksa.svg'
};

const useScrollAndMobile = () => {
  const [state, setState] = useState({ isScrolled: false, isMobile: false });

  useEffect(() => {
    const handleScroll = () => setState(prev => ({ ...prev, isScrolled: window.scrollY > 50 }));
    const handleResize = () => setState(prev => ({ ...prev, isMobile: window.innerWidth <= 768 }));

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return state;
};

const useLoadingScreen = (language, toggleLanguage) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLanguageToggle = useCallback(() => {
    if (isLoading) return;
    setIsLoading(true);

    const loadingScreen = document.createElement('div');
    loadingScreen.className = 'fixed inset-0 z-50 bg-black bg-opacity-50 opacity-0 transition-opacity duration-300';
    loadingScreen.innerHTML = `
      <div class="flex justify-center items-center h-full">
        <div class="relative">
          <div class="w-24 h-24 rounded-full border-t-4 border-b-4 border-white animate-spin"></div>
          <div class="flex absolute inset-0 justify-center items-center">
            <span class="text-sm font-medium text-white">${language === 'en' ? 'جاري التحميل' : 'Loading'}...</span>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(loadingScreen);
    requestAnimationFrame(() => loadingScreen.classList.add('opacity-100'));

    setTimeout(() => {
      loadingScreen.classList.remove('opacity-100');
      loadingScreen.classList.add('opacity-0');
      setTimeout(() => {
        toggleLanguage();
        setIsLoading(false);
        document.body.removeChild(loadingScreen);
      }, 300);
    }, 1000);
  }, [isLoading, language, toggleLanguage]);

  return [isLoading, handleLanguageToggle];
};

const LanguageToggleButton = ({ className, Location, isMobileView }) => {
  const { language, toggleLanguage } = useLanguage();
  const { isScrolled, isMobile } = useScrollAndMobile();
  const [isLoading, handleClick] = useLoadingScreen(language, toggleLanguage);

  const textColor = isMobileView && Location === 'Menu' 
    ? 'text-gray-700'
    : isScrolled ? 'text-gray-700' : 'text-white';

  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className={`
        flex relative items-center rounded-lg transition-all duration-300 ml-4
        ${textColor}
        ${isLoading ? '' : 'hover:scale-105'}
        ${className || ''}
      `}
    >
      <span className="flex gap-2 items-center duration-300">
        {isMobileView && Location === 'Menu' ? (
          <>
            <img
              src={FLAGS[language]}
              alt={language === 'ar' ? 'Saudi Arabia' : 'Egypt'}
              className="object-cover w-5 h-5 rounded-full"
            />
            <span>{language === 'ar' ? 'English' : 'العربية'}</span>
          </>
        ) : (
          <img
            src={FLAGS[language]}
            alt={language === 'ar' ? 'Saudi Arabia' : 'Egypt'}
            className="object-cover w-6 h-6 rounded-full"
          />
        )}
      </span>
    </button>
  );
};

export default LanguageToggleButton;